import React, { useEffect, useState } from "react";
// import numberUtil from "../../util/numberUtil";
import "./index.scss";
import Select from "../select";
import ToolTip from "../toolTip";
import Tags from "../tags";

import ReactEcharts from "echarts-for-react";
import { formatNumber } from "@/tool/utils";
import LoadingOutlined from "../loadingOutlined";
import Chartloading from "../loadingOutlined/chartloading";
import UpdatTime from "./updateTime";

type Props = {
  types: string[];
  typeValue: string;
  onTypeChange: (value: string) => void;
  selectType: "day" | "node";
  updateTime: number;
  yData: string[];
  datas: any[];
  loading: boolean;
  hiddenZoom?: boolean;
};

export default function Index(props: Props) {
  let zoomStart = 80;
  const length = props.yData?.length || 0;
  if (length <= 20) {
    zoomStart = 50;
  } else if (length <= 50) {
    zoomStart = 80;
  } else if (length <= 200) {
    zoomStart = 90;
  } else if (length > 200) {
    zoomStart = 95;
  }
  const yData = props.yData
    ? props.yData.map((title) => {
        if (props.typeValue === "1D") {
          return `${title.slice(0, 4)}/${title.slice(4, 6)}/${title.slice(
            6,
            8
          )} ${title.slice(8, 10)}:00`;
        } else {
          return `${title.slice(0, 4)}/${title.slice(4, 6)}/${title.slice(
            6,
            8
          )}`;
        }
      })
    : [];

  const getChartOption = () => {
    return {
      color: props.datas.map((item: any) => {
        return item.color;
      }),
      tooltip: {
        trigger: "axis",
        axisPointer: {
          lineStyle: {
            color: "#9DAFBE",
          },
        },
        formatter: (params: any) => {
          // console.log("params[0]", params);
          try {
            let title = params[0].name;
            let itemDiv = params.map((item: any) => {
              const value = item.data === 0.1 ? 0 : item.data;
              return `<div class="tooltipItem">
                                <div>${item.marker}${item.seriesName}</div>
                                <div>${formatNumber(value, {
                                  decimals: 2,
                                })}</div>
                            </div>`;
            });

            title = title.replace(/\//g, "-");
            return `<div class="tooltipContainer">
                            <div class="title">${title}</div>
                            ${itemDiv.join("")}
                        </div>`;
          } catch (error) {
            return `<div class="tooltipContainer">
                         ${error}
                    </div>`;
          }
        },
      },
      // legend: {
      //     data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine','Direct1', 'Search Engine2']
      // },
      grid: {
        left: "3%",
        right: "10%",
        bottom: props.hiddenZoom ? "3" : "15%",
        top: "3%",
        containLabel: true,
      },
      toolbox: {
        // feature: {
        //     saveAsImage: {}
        // }
      },
      dataZoom:
        props.hiddenZoom || props.yData?.length <= 10
          ? undefined
          : [
              {
                start: zoomStart,
                end: 100,
                right: "70px",
                left: "70px",
                bottom: "10px",
                textStyle: {
                  color: "#9dafbe",
                  fontFamily: "Arial",
                },
                dataBackground: {
                  //数据阴影的样式。
                  lineStyle: {
                    color: "#9dafbe",
                  }, //阴影的线条样式
                  areaStyle: {
                    color: "#9dafbe",
                  }, //阴影的填充样式
                },
              },
              {
                type: "inside",
                realtime: true,
                start: zoomStart,
                end: 100,
              },
            ],
      xAxis: {
        type: "category",
        boundaryGap: false,
        axisLabel: {
          // interval:"6px",
          color: "#9dafbe",
          formatter: (item: any) => {
            if (props.typeValue === "1D") {
              const itemArray = item.split(" ");
              return itemArray[1];
            } else {
              const itemArray = item.split("/");
              return `${itemArray[1]}-${itemArray[2]}`;
            }
            // return `${item.slice(0, 4)}-${item.slice(4, 6)}-${item.slice(6, 8)}`
          },
          fontFamily: "Arial",
          margin: 6,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: "#9dafbe",
          },
        },
        data: yData,
      },
      yAxis: {
        type: "log",
        axisLabel: {
          // interval:"6px",
          formatter: (value: any) => {
            return formatNumber(value, { decimals: 2 });
          },
          color: "#9dafbe",
          fontFamily: "Arial",
          margin: 6,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#1A283533",
            width: 1,
          },
        },
        axisLine: {
          lineStyle: {
            color: "#9dafbe",
          },
        },
      },
      series: props.datas.map((item) => {
        item.symbol = "none";
        item.data = item.data.map((e: any) => {
          if (e === 0) {
            return undefined;
          } else {
            return e;
          }
        });
        return item;
      }),
    };
  };

  return (
    <div className="echartsContainer">
      {props.selectType == "day" && (
        <div className="echarts-head">
          {props.selectType != "day" && (
            <ToolTip title="Change the unit of measure that suits your needs." />
          )}{" "}
          <Select
            datas={props.types}
            value={props.typeValue}
            onChange={props.onTypeChange}
          />
        </div>
      )}
      <div className="echartsPanel">
        <Chartloading spin={props.loading}>
          <div className="echarts">
            <ReactEcharts
              className="echarts-body"
              option={getChartOption()}
            ></ReactEcharts>
          </div>
          <Tags datas={props.datas} />
          <UpdatTime updateTime={props.updateTime} />
        </Chartloading>
      </div>
    </div>
  );
}
